import { render, staticRenderFns } from "./ThePageHeader.vue?vue&type=template&id=46807d94&"
import script from "./ThePageHeader.vue?vue&type=script&lang=js&"
export * from "./ThePageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports